<template>
  <div class="account-view">
    <div class="mb-6">
      <SidebarToggleView />
      <span class="display-2">Nutzerprofil</span>
    </div>
    <v-card class="my-4" v-if="userdata">
      <v-card-title class="font-weight-bold">
        Nutzerdaten
      </v-card-title>
      <v-card-text>
        <v-text-field
          readonly
          v-if="userinfo"
          v-model="userinfo.attributes.email"
          v-on:change="updateUserEmail()"
          label="Email"
          :messages="userinfo.attributes.email_verified ? 'Verifizierte Email' : 'Email ist nicht verifiziert'"
        >
          <v-icon slot="prepend-inner" :color="userinfo.attributes.email_verified ? 'green' : 'grey'">
            verified_user
          </v-icon>
        </v-text-field>
        <v-text-field v-model="userdata.fullname" v-on:change="updateUserdata()" label="Nutzername" />
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="show_change_password_dialog = !show_change_password_dialog">Passwort ändern</v-btn>
        <v-btn text @click="show_change_email_dialog = !show_change_email_dialog">Email ändern</v-btn>
        <v-btn
          text
          v-if="!userinfo.attributes.email_verified"
          @click="show_verification_dialog = !show_verification_dialog"
          >Email verifizieren</v-btn
        >
      </v-card-actions>
    </v-card>
    <AVVView></AVVView>
    <PlanView></PlanView>
    <!--<amplify-sign-out></amplify-sign-out>-->
    <v-btn outlined color="primary" @click="onSignOut()">Abmelden</v-btn>
    <ChangePasswordView :showThis="show_change_password_dialog" v-on:discard="show_change_password_dialog = false" />
    <ChangeEmailView :showThis="show_change_email_dialog" v-on:discard="discardChangeEmailDialog()" />
    <VerifyEmailView :showThis="show_verification_dialog" v-on:discard="discardVerifyEmailDialog()" />
  </div>
</template>

<script>
import { signOut, getUser } from "./userauth/auth.js";

//import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from "aws-amplify-vue";
import PlanView from "./PlanView";
import AVVView from "./AVVView";
import ChangePasswordView from "./ChangePasswordView";
import SidebarToggleView from "./SidebarToggleView";
import ChangeEmailView from "./userauth/ChangeEmailView";
import VerifyEmailView from "./userauth/VerifyEmailView";

export default {
  name: "AccountView",
  props: {
    msg: String,
  },
  components: {
    PlanView,
    AVVView,
    ChangePasswordView,
    SidebarToggleView,
    ChangeEmailView,
    VerifyEmailView,
  },
  computed: {
    userdata: {
      get: function() {
        return this.$store.state.userdata.value;
      },
      set: function(value) {
        this.$store.dispatch("setUserdata", value);
      },
    },
    userinfo() {
      return this.$store.state.originalStore.user_info;
    },
  },
  methods: {
    updateUserdata() {
      this.userdata = this.userdata;
    },
    updateUserinfo() {
      AmplifyEventBus.$emit("updateAuthData");
      //console.log(this.userinfo)
    },
    onSignOut() {
      signOut();
      this.$router.push("/home");
    },
    discardChangeEmailDialog() {
      this.updateUserinfo();
      this.show_change_email_dialog = false;
    },
    discardVerifyEmailDialog() {
      this.updateUserinfo();
      this.show_verification_dialog = false;
    },
  },
  data() {
    return {
      show_change_password_dialog: false,
      show_change_email_dialog: false,
      show_verification_dialog: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.hidden-sm-and-down .v-icon {
  color: green !important;
}
</style>
